/* eslint-disable */
import React, { useEffect, useMemo, useState } from 'react';
import type { FC } from 'react';
import { Grid, Stack } from '@mui/material';
import { FormikProps } from 'formik';
import { isEmpty } from 'lodash';
import { FormRenderProps } from 'react-final-form';
import { useParams } from 'react-router-dom';
import { API_E2E_POST_FORM_ABANDONED } from 'src/api/e2e-request-objects';
import { apiRequest } from 'src/api/request-handler';
import { LocalStorageE } from 'src/e2e-redesign/layout';
import useE2eStore from 'src/e2e-store';
import { FieldDetailI, FieldDetails } from 'src/interfaces/application.interfaces';
import DynamicSections from 'src/pages/application/components/dynamic-sections';
import { BREAD_LENDER_ID } from 'src/utils/bread-e2e-constants';

import { extendFieldsForBread, transformStaticDisclosuresToAccordion } from '../logic/bread-e2e-integration';

interface DynamicSectionsI {
  updatedFields: FieldDetailI[];
  fieldDetailType: FieldDetails;
  formProps?: FormikProps<any>;
  required_fields: string[];
  formRenderProps: FormRenderProps;
  // modified line
  registerFieldRef?: (fieldId: string, element: HTMLElement | null) => void;
  handleFieldBlur?: (fieldId: string) => void;
  // end modified
}

const AbandonedFormWrapper: FC<DynamicSectionsI> = (props) => {
  const { updatedFields, fieldDetailType, required_fields, formRenderProps } = props;
  const { aaso_id, e2e_form_id, store_uuid } = useParams();
  const e2eStore = useE2eStore((state) => state);

  useEffect(() => {
    const handleBeforeUnload = async (event: BeforeUnloadEvent) => {
      // Prevent immediate page unload to allow form saving
      event.preventDefault();
      event.returnValue = '';
      
      // Only save if form is not already submitted
      if (!e2eStore?.form_values?.submitted) {
        try {
          const formValues = formRenderProps.values;
          const mLinkId = window.localStorage.getItem(LocalStorageE.mLink);
          const sourceId = window.localStorage.getItem(LocalStorageE.source);
          
          await apiRequest(API_E2E_POST_FORM_ABANDONED, {
            body: { form: formValues, mLinkId, sourceId },
            params: { e2e_form_id, aaso_id, store_uuid },
          });
        } catch (error) {
          // Log error but don't block page unload
          console.error('Failed to save abandoned form:', error);
        }
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [formRenderProps.values, e2eStore.form_values, e2e_form_id, aaso_id, store_uuid]);

  const e2eForm = e2eStore.application_settings?.e2e?.e2e_forms.find((form) => form.id === e2e_form_id);
  const containsBread = e2eForm?.paths
    .find((path) => path.id == e2eStore.aaso.current_path_id)
    ?.lenders?.includes(BREAD_LENDER_ID);
  const extendedFields = useMemo(
    () => (containsBread ? extendFieldsForBread(updatedFields) : transformStaticDisclosuresToAccordion(updatedFields)),
    [updatedFields, e2eStore.application_settings],
  );

  // Commenting this out so we only save on beforeunload
  // useEffect(() => {
  //   // saving the form after 5 seconds to avoid idle timeout issue
  //   /**
  //    * REMOVE THIS FOR NOW BECAUSE THIS CAUSES ISSUES WITH DEV
  //    */
  //   const saveForm = async () => {
  //     if (!shouldSave) return; // Exit if already processed
  //     shouldSave = false; // Immediately mark as processed
  //     if (!e2eStore?.form_values?.submitted) {
  //       const formValues = formRenderProps.values; // the form values
  //       const mLinkId = window.localStorage.getItem(LocalStorageE.mLink);
  //       const sourceId = window.localStorage.getItem(LocalStorageE.source);
  //       const res = await apiRequest(API_E2E_POST_FORM_ABANDONED, {
  //         body: { form: formValues, mLinkId, sourceId },
  //         params: { e2e_form_id, aaso_id, store_uuid },
  //       });
  //       if (res) {
  //       }
  //     }
  //   };
  //   // This might be causing submitted = false
  //   if (
  //     !savedAbandoned &&
  //     formRenderProps?.values &&
  //     !isEmpty(formRenderProps?.values)
  //     // e2eStore?.form_values &&
  //     // !isEmpty(e2eStore?.form_values)
  //   ) {
  //     setSaveAbandoned(true);
  //     saveForm();
  //     // setTimeout(async () => {
  //     //   await saveForm();
  //     // }, 5000);
  //   }
  // }, [formRenderProps.values, e2eStore.form_values, savedAbandoned]);
  return (
    <Stack direction={'column'} spacing={3}>
      <Grid container spacing={1}>
        <DynamicSections
          containsBread={containsBread}
          selectedFormDetails={extendedFields}
          fieldDetailType={fieldDetailType}
          formProps={formRenderProps}
          required_fields={required_fields}
          // modified line
          registerFieldRef={props.registerFieldRef}
          handleFieldBlur={props.handleFieldBlur}
          // end modified
        />
      </Grid>
    </Stack>
  );
};

export default AbandonedFormWrapper;
